import React from "react";

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: "white" | "light" | "primary" | "dark";
}

const Section: React.FC<SectionProps> = ({
  children,
  className = "",
  id,
  background = "white",
}) => {
  const backgrounds = {
    white: "bg-white",
    light: "bg-neutral-50",
    primary: "bg-primary",
    dark: "bg-dark",
  };

  return (
    <section
      id={id}
      className={`py-16 md:py-40 ${backgrounds[background]} ${className}`}
    >
      <div
        className={`app-container mx-auto px-4 ${
          background === "dark" ? "text-white" : ""
        } `}
      >
        {children}
      </div>
    </section>
  );
};

export default Section;
